import React, { useEffect, useState } from 'react';
import './Courses.css';

const fallbackCourses = [
  { id: 1, name: 'Mathematics', classRange: 'All Classes', icon: '📐', description: 'Build a strong foundation in algebra, geometry, and arithmetic with expert guidance.', batchSize: 'Max 15 Students' },
  { id: 2, name: 'Science', classRange: 'All Classes', icon: '🔬', description: 'Explore Physics, Chemistry, and Biology with conceptual clarity and hands-on examples.', batchSize: 'Max 15 Students' },
  { id: 3, name: 'English', classRange: 'All Classes', icon: '📚', description: 'Grammar, comprehension, creative writing, and literature made simple and effective.', batchSize: 'Max 15 Students' },
  { id: 4, name: 'Social Science (SST)', classRange: 'All Classes', icon: '🌍', description: 'History, Geography, Civics, and Economics explained with clarity and real-world context.', batchSize: 'Max 15 Students' },
  { id: 5, name: 'Computers', classRange: 'All Classes', icon: '💻', description: 'Fundamentals of computers, MS Office, programming basics, and digital literacy.', batchSize: 'Max 15 Students' },
  { id: 6, name: 'Hindi', classRange: 'All Classes', icon: '🖊️', description: 'Grammar, comprehension, essay writing, and literature in Hindi language.', batchSize: 'Max 15 Students' },
  { id: 7, name: 'Sanskrit', classRange: 'All Classes', icon: '📜', description: 'Classical Sanskrit grammar, translation, and literature for board exam success.', batchSize: 'Max 15 Students' },
];

export default function Courses() {
  const [courses, setCourses] = useState(fallbackCourses);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/courses')
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.courses) setCourses(data.courses);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="courses">
      <div className="courses__container">
        <h2 className="section-title">Our Courses</h2>
        <div className="section-divider"></div>
        <p className="section-subtitle">
          Comprehensive coaching programs designed for academic excellence across all major subjects
        </p>

        {loading ? (
          <div className="courses__loading">
            {[1,2,3,4,5,6].map(i => <div key={i} className="courses__skeleton"></div>)}
          </div>
        ) : (
          <div className="courses__grid">
            {courses.map((course) => (
              <div key={course.id} className="course-card">
                <div className="course-card__icon">{course.icon}</div>
                <div className="course-card__tag">{course.classRange}</div>
                <h3 className="course-card__name">{course.name}</h3>
                <p className="course-card__desc">{course.description}</p>
                <div className="course-card__meta">
                  <span>👥 {course.batchSize}</span>
                </div>
                <button className="course-card__btn" onClick={scrollToContact}>
                  Enroll Now →
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
